const successStories = [
    {
        id: 0,
        title:"Green Grocery",
        desc:"SmartOffice's pre-built tax templates ensure we stay compliant with local regulations, eliminating tax-related headaches.",
        logo: "Green Grocery.jpg",
        
    },
    {
        id: 1,
        title:"ILLIYEEN",
        desc:"SmartPeople's real-time monitoring helps us proactively identify and address any unusual user activity, boosting security.",
        logo: "illiyeen.png",
        img:"illiyeen_bg.png"
    },
    {
        id: 2,
        title:"Ikigai",
        desc:"As an HR solutions provider, we’ve found SmartOffice HRMS valuable—its clean UI, ease of use, fast performance, and scalability have been impressive.",
        logo: "ikaigai HR.jpg",
       
    },
    {
        id: 3,
        title:"Legends",
        desc:"SmartPeople's exceptional customer experience and support make them a standout HRMS provider.",
        logo: "legends.png",
        
    },
    {
        id: 5,
        title:"",
        desc:"",
        logo: "pathao.svg",
        fullLogo: true,
    },
    {
        id: 4,
        title:"Bangas",
        desc:"SmartOffice has helped us organize key HR tasks more efficiently. It’s practical, offers useful features, and fits well with our day-to-day needs.",
        logo: "bangas.jpg",
        
    },
];

export default successStories;